import './select-receipt.scss';

import { forEach } from 'lodash';

import type { HasFiscalPrinter } from '@pos/app/scripts/services/has-fiscal-printer';
import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Endpoint } from '@core/app/scripts/services/endpoint';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { Mask } from '@core/app/scripts/services/mask';
import { Moment } from '@shared/app/scripts/vendor/moment';
import { Persist } from '@core/app/scripts/services/persist';
import { RetailTransactions } from '@shared/app/scripts/services/retail-transactions';
import { TimeKeeper } from '@core/app/scripts/services/time-keeper';

/*
 * Component responsible for /select-receipt route.
 */
angular
  .module('posApp')
  .directive(
    'selectReceipt',
    (
      $http: ng.IHttpService,
      $log: ng.ILogService,
      $q: ng.IQService,
      $timeout: ng.ITimeoutService,
      displayMessage: DisplayMessage,
      endpoint: Endpoint,
      hasFiscalPrinter: HasFiscalPrinter,
      locationManager: LocationManager,
      mask: Mask,
      moment: Moment,
      navigateTo: NavigateTo,
      persist: Persist,
      pos,
      retailTransactions: RetailTransactions,
      sales,
      timeKeeper: TimeKeeper,
      salesCalculations,
      translate: ng.translate.ITranslateService,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./select-receipt.html').default,

      link: function ($scope: any, element, attrs) {
        const $translate = translate;

        $scope.hasFiscalPrinter = hasFiscalPrinter;

        const year = '';
        $scope.smartReceiptList = [];

        $scope.types = [
          {
            type: 2,
            typestr: $translate.instant('Sales'),
          },
          {
            type: 'withdrawal',
            typestr: $translate.instant('Withdrawal'),
          },
          {
            type: 'pending',
            typestr: $translate.instant('Pending'),
          },
        ];

        if (!hasFiscalPrinter()) {
          $scope.types.push({
            type: 3,
            typestr: $translate.instant('Transit'),
          });

          $scope.types.push({
            type: 9,
            typestr: $translate.instant('Consignment'),
          });
        }

        console.log('create select-receipt');

        $scope.shopnames = [];
        $scope.date = timeKeeper.getLocalDate();
        $scope.datebuff = '';
        $scope.transactions = [];
        $scope.transitFromIcon = 'img/shipping/transit_from.png';
        $scope.transitToIcon = 'img/shipping/transit_to.png';

        $scope.selectedLine = -1;

        $scope.storeFilters = () => {
          persist.set('selectreceipt.shopId', $scope.shopId);
          persist.set('selectreceipt.date', $scope.date.toISOString());
          persist.set('selectreceipt.type', $scope.filter.type);
        };

        $scope.restoreFilters = () => {
          const shopId = persist.get('selectreceipt.shopId'),
            date = persist.get('selectreceipt.date'),
            type = persist.get('selectreceipt.type');

          if (shopId) {
            if (shopId === 'null') {
              $scope.shopId = null;
            } else {
              $scope.shopId = shopId;
            }
          }

          if (date) {
            $scope.date = new Date(date);
          }

          if (type === '2') {
            $scope.filter.type = 2;
          } else if (type === '3') {
            $scope.filter.type = 3;
          } else if (type === '9') {
            $scope.filter.type = 9;
          } else if (type === 'pending') {
            $scope.filter.type = 'pending';
          } else if (type) {
            $scope.filter.type = type;
          }
        };

        $scope.clearFiltersCache = () => {
          persist.remove('selectreceipt.shopId');
          persist.remove('selectreceipt.date');
          persist.remove('selectreceipt.type');
        };

        $scope.selectReceipt = (receipt) => {
          if (
            receipt.type === '2' ||
            receipt.type === '9' ||
            receipt.type === 'pending'
          ) {
            navigateTo(
              `pos.route#sales-transaction-summary/${
                receipt._id
              }/${encodeURIComponent('pos.route#select-receipt')}`,
            );
          } else {
            pos.selectReceipt(receipt, 'pos.route#select-receipt');
          }
        };

        $scope.getClass = (ind) => {
          if (ind === $scope.selectedLine) {
            return 'ui-btn-active';
          } else {
            return '';
          }
        };

        // ngInit
        //Store warehouses into dropdown
        for (const wareHouse in locationManager.all) {
          $scope.shopnames.push({
            shopId: locationManager.all[wareHouse].wh,
            shopnametxt: locationManager.all[wareHouse].name,
          });
        }

        // Load with defaults
        $scope.date = timeKeeper.getLocalDate();
        $scope.shopId = locationManager.current.wh;
        $scope.filter = {
          type: 2,
        };

        $scope.restoreFilters();

        loadTransactions();

        function loadTransactions() {
          $scope.transactions = [];
          let date = $scope.date,
            filter;

          if (isNaN(date.getTime())) {
            $log.error('[SelectReceipt] Unparsable date!', $scope.date);
            return;
          }

          date = date ? date : timeKeeper.getLocalDate();

          filter = {
            startDate: moment(date).startOf('day').format(),
            endDate: moment(date).endOf('day').format(),
          };

          if ($scope.type !== -1) {
            filter.type = $scope.filter.type;
          }

          // restoreFilters sends 'null'
          if ($scope.shopId !== null && $scope.shopId !== 'null') {
            filter.warehouseId = $scope.shopId;
          }

          displayMessage.showLoading();

          const fields = [
            // default fields
            'nr',
            'type',
            'shop',
            'status',
            'created',
            'overallReceiptDiscount',
            'transit',
            'totalAmount',
            'totalDiscount',
            'totalDiscountCoupon',
            'totalCoupon',
            'totalPaid',
            'totalNumber',
            'totalReturn',
            'fiscal_receipt_nr',
            'fiscal_shift_nr',
            // addition fields
            'payments',
            // Fiskaly fields
            'fiskaly_invoice_id',
            'fiskaly_api_response',
          ];

          // Use /sales/get-pending endpoint for pending transactions
          if ($scope.filter.type === 'pending') {
            const spynlEndpoint = endpoint.getSpynlEndpoint();
            const url = spynlEndpoint + '/sales/get-pending';

            $http.post(url, { filter: filter }, { withCredentials: true }).then(
              (response) => {
                mask.hide();
                if (
                  response &&
                  response.data &&
                  response.data.status === 'ok' &&
                  response.data.data
                ) {
                  const transactions = response.data.data;
                  if (!transactions || transactions.length === 0) {
                    $log.log('[SelectReceipt] No pending items to load');
                    return;
                  }

                  $log.log('[SelectReceipt] Pending transactions loading');

                  $scope.transactions = transactions;

                  forEach($scope.transactions, (transaction) => {
                    transaction.total = salesCalculations.total(transaction);
                  });

                  $scope.transactions.sort((a, b) => {
                    if (a.created && b.created) {
                      a = a.created.date;
                      b = b.created.date;
                      return a > b ? -1 : a < b ? 1 : 0;
                    }
                  });

                  for (const i in $scope.transactions) {
                    if ($scope.transactions[i].shop) {
                      $scope.transactions[i].shopname =
                        $scope.transactions[i].shop.name;
                    }
                  }
                }
              },
              (error) => {
                mask.hide();
                $log.error(
                  '[SelectReceipt] Failed to load pending transactions:',
                  error,
                );
              },
            );
          } else {
            // Use regular retailTransactions.filter for other types
            retailTransactions.filter(filter, 0, 1000, fields).then(
              (transactions) => {
                mask.hide();
                if (!transactions || transactions.length === 0) {
                  $log.log('[SelectReceipt] No items to load');
                  return;
                }

                $log.log('[SelectReceipt] Transactions loading');

                $scope.transactions = transactions;

                forEach($scope.transactions, (transaction) => {
                  transaction.total = salesCalculations.total(transaction);
                });

                $scope.transactions.sort((a, b) => {
                  if (a.created && b.created) {
                    a = a.created.date;
                    b = b.created.date;
                    return a > b ? -1 : a < b ? 1 : 0;
                  }
                });

                for (const i in $scope.transactions) {
                  if ($scope.transactions[i].shop) {
                    $scope.transactions[i].shopname =
                      $scope.transactions[i].shop.name;
                  }
                }
              },
              () => {
                mask.hide();
              },
            );
          }
        }

        $scope.selectCurrentLine = (currentLine) => {
          $log.log('currentLine: ' + currentLine._id);
          $scope.selectedRow = currentLine;
          $scope.toggleSelect(currentLine._id);
        };

        $scope.toggleSelect = (ind) => {
          $scope.selectedLine = ind;
        };

        //Reload transactions after change the search texts
        let filterChangeTimeout;

        $scope.searchOnBlur = () => {
          /*
           * Prevent filters from changing too rapidly and causing
           * unecessary network traffic such as when a user is typing
           */
          if (filterChangeTimeout) {
            $timeout.cancel(filterChangeTimeout);
          }
          filterChangeTimeout = $timeout(() => {
            loadTransactions();
            $scope.storeFilters();
          }, 750);
        };

        //Custom filter for grid
        $scope.search = {};

        $scope.getTransactionTotal = (transaction) => {
          return salesCalculations.total(transaction);
        };

        $scope.getClass = (transaction) => {
          if (transaction?.type === 'withdrawal') {
            if (transaction.payments?.cash > 0) {
              return 'green';
            }
            if (transaction.payments?.cash < 0) {
              return 'red';
            }
          }
          if (transaction?.type === 'pending') {
            return 'pending-transaction';
          }
        };

        $scope.isPendingFiskaly = (transaction) => {
          return (
            transaction?.type === 'pending' && transaction?.fiskaly_invoice_id
          );
        };

        $scope.getLastFiskalyError = (transaction) => {
          if (
            !transaction?.fiskaly_api_response ||
            !Array.isArray(transaction.fiskaly_api_response) ||
            transaction.fiskaly_api_response.length === 0
          ) {
            return null;
          }

          // Get the last error response
          const responses = transaction.fiskaly_api_response;
          for (let i = responses.length - 1; i >= 0; i--) {
            if (responses[i].status === 'error') {
              return responses[i];
            }
          }
          return null;
        };

        $scope.retryFiskaly = (transaction, event) => {
          if (event) {
            event.stopPropagation();
          }

          if (!transaction || !transaction._id) {
            $log.error('[SelectReceipt] Cannot retry: transaction missing _id');
            displayMessage.message(
              $translate.instant('CannotRetryTransaction'),
            );
            return;
          }

          displayMessage.showLoading();

          // Load the full transaction using retail-transactions (supports pending transactions)
          retailTransactions
            .filter({ _id: transaction._id })
            .then((transactions) => {
              if (!transactions || transactions.length === 0) {
                throw new Error('Transaction not found');
              }
              const fullTransaction = transactions[0];

              // Ensure type is 'pending' and _id is preserved for re-entrant update
              fullTransaction.type = 'pending';
              if (!fullTransaction._id) {
                fullTransaction._id = transaction._id;
              }

              // Call sales.add to trigger Fiskaly retry
              return sales.add(fullTransaction);
            })
            .then(() => {
              mask.hide();
              displayMessage.message(
                $translate.instant('FiskalyRetryInitiated'),
              );
              // Reload transactions after a short delay
              $timeout(() => {
                loadTransactions();
              }, 1000);
            })
            .catch((error) => {
              mask.hide();
              $log.error('[SelectReceipt] Fiskaly retry failed:', error);
              displayMessage.message($translate.instant('FiskalyRetryFailed'));
            });
        };

        $scope.toggleErrorDetails = (transaction) => {
          transaction._showErrorDetails = !transaction._showErrorDetails;
        };
      },
    }),
  );
